import React, { Component } from 'react'
import SeniorenplatformItem from "../SeniorenplatformItem/SeniorenplatformItem";
import SeniorenplatformItemTable from "../SeniorenplatformItemTable/SeniorenplatformItemTable";
import { SeniorenPaginationText, SeniorenplatformPagination } from "../SeniorenPagination/SeniorenPagination";
import { Loading } from '../../FicheLijst/Loading/Loading';

export default class SeniorenplatformList extends Component {
    constructor(props) {
        super();
    }

    render() {
        return (
            <div className="c-senioren__list">
                <form className="c-senioren__search">
                    <input
                        className="c-senioren__search__input"
                        type="text"
                        placeholder={this.props.dictionary.zoekenPlaceholder}
                        onChange={event => this.props.searchUpdated(event.target.value)}
                    />
                    <button className="c-senioren__search__icon" type="submit"><i className="fa fa-fw fa-search"></i></button>
                </form>
                <div className="filter-toggle">
                    <div className="buttons">
                        <button className="c-senioren__button c-senioren__button--large c-senioren__button--mobile c-senioren__button--secondary" onClick={() => this.props.filterMobile()}>{this.props.dictionary.filteren}</button>
                        <div className="c-senioren__switch">
                            <label className="switch">
                                <input className="switch-checkbox" type="checkbox" onChange={(e) => this.props.toggleView(e)} />
                                <span className="slider">
                                    <span className="left"><i className="fa fa-table"></i></span>
                                    <span className="right"><i className="fa fa-list"></i></span>
                                </span>
                            </label>
                        </div>
                    </div>
                    {this.props.entries.length !== 0 && this.props.loading === false &&
                        <SeniorenPaginationText
                            pageValueMin={this.props.pageValueMin}
                            pageValueMax={this.props.pageValueMax}
                            totalItems={this.props.totalItems}
                            dictionary={this.props.dictionary}/>
                    }
                </div>
                {this.props.loading 
                ? <Loading/> 
                : this.props.entries.length !== 0 && this.props.loading === false ?
                    <div>
                        {this.props.toggleViewValue === false
                            ? <div className="c-senioren__items u-clear">
                                {this.props.entries !== undefined && this.props.entries !== null && this.props.loading === false &&
                                    this.props.entries.map((item, index) => (
                                        <SeniorenplatformItem
                                            item={item}
                                            key={index}
                                            dictionary={this.props.dictionary}
                                            toggleIsFavorites={this.props.toggleIsFavorites}
                                            getDetailsOfItem={this.props.getDetailsOfItem} />
                                    ))
                                }
                                {this.props.loading &&
                                    <div className="status loading">
                                        <i className="loader"></i>
                                        <h1>{this.props.dictionary.Laden}...</h1>
                                    </div>
                                }
                                {this.props.entries.length === 0 && this.props.loading === false &&
                                    <div className="status empty">
                                        <h1>{this.props.dictionary.geenResultaten}...</h1>
                                    </div>
                                }
                            </div>
                            : this.props.toggleViewValue === true &&
                            <div className="c-senioren__tableview u-clear">
                                <div className="c-senioren__tableview--header">
                                    <span className="name">{this.props.dictionary.naam}</span>
                                    <span className="category">{this.props.dictionary.categorie}</span>
                                </div>
                                {this.props.entries !== undefined && this.props.entries !== null && this.props.loading === false &&
                                    this.props.entries.map((item, index) => (
                                        <SeniorenplatformItemTable
                                            item={item}
                                            key={index}
                                            toggleIsFavorites={this.props.toggleIsFavorites}
                                            getDetailsOfItem={this.props.getDetailsOfItem}
                                            dictionary={this.props.dictionary} />
                                    ))
                                }
                                {this.props.loading &&
                                    <div className="status loading">
                                        <i className="loader"></i>
                                        <h1>{this.props.dictionary.Laden}...</h1>
                                    </div>
                                }
                                {this.props.entries.length === 0 && this.props.loading === false &&
                                    <div className="status empty">
                                        <h1>{this.props.dictionary.geenResultaten}...</h1>
                                    </div>
                                }
                            </div>
                        }
                        <SeniorenplatformPagination
                            pageValueMin={this.props.pageValueMin}
                            pageValueMax={this.props.pageValueMax}
                            totalItems={this.props.totalItems}
                            pageDown={this.props.pageDown}
                            pageUp={this.props.pageUp}
                            disabledMin={this.props.disabledMin}
                            disabledMax={this.props.disabledMax}
                            dictionary={this.props.dictionary} />
                    </div>
                    : <h4>
                        Geen resultaten gevonden...
                    </h4>
                }
            </div>
        );
    }
}